/**
 * 内容处理模型定义
 * 定义内容类型和结构化数据接口
 *
 * 核心功能：
 * 1. 定义支持的内容类型（文本、PDF、网页）
 * 2. 提供内容解析和处理的数据结构
 * 3. 支持上下文数据提取和组织
 * 4. 跟踪内容统计信息和元数据
 * 5. 处理语言检测和内容处理结果
 */
/**
 * 内容类型枚举
 */
export var ContentType;
(function (ContentType) {
    ContentType["TEXT"] = "text";
    ContentType["PDF"] = "pdf";
    ContentType["WEB"] = "web";
})(ContentType || (ContentType = {}));
//# sourceMappingURL=content.js.map